module.exports = __webpack_public_path__ + "img/page10img1.b45bff59.png";